import React from "react";

export class Loading extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {

        // show/hide
        var classes = "overlay loading";

        if(!this.props.open) {
            classes += " hidden";
        }


        return (
            <div className={classes}>
                <div className="overlay-inner">
                    <div className="body text-center">Loading...</div>
                </div>
            </div>
        );
    }
}


Loading.defaultProps = {
    open: false
};
